module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-Bold.cd0e440.woff";